/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_IntroInputs */

const en_guide_what_is_json_intro = /** @type {(inputs: Guide_What_Is_Json_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (JavaScript Object Notation) is a lightweight, text-based data interchange format that has become the standard for transmitting data between web applications and servers. Despite its name, JSON is language-independent and is supported by virtually every modern programming language.`)
};

const ko_guide_what_is_json_intro = /** @type {(inputs: Guide_What_Is_Json_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON(JavaScript Object Notation)은 웹 애플리케이션과 서버 간의 데이터 전송 표준이 된 경량 텍스트 기반 데이터 교환 포맷입니다. 이름에 JavaScript가 들어가지만, JSON은 언어에 독립적이며 거의 모든 현대 프로그래밍 언어에서 지원됩니다.`)
};

const ja_guide_what_is_json_intro = /** @type {(inputs: Guide_What_Is_Json_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON（JavaScript Object Notation）は、Webアプリケーションとサーバーとのデータ送受信の標準となった軽量なテキストベースのデータ交換フォーマットです。名前にJavaScriptが含まれていますが、JSONは言語に依存せず、事実上すべての現代的なプログラミング言語でサポートされています。`)
};

/**
* | output |
* | --- |
* | "JSON (JavaScript Object Notation) is a lightweight, text-based data interchange format that has become the standard for transmitting data between web applica..." |
*
* @param {Guide_What_Is_Json_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_intro = /** @type {((inputs?: Guide_What_Is_Json_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_intro(inputs)
	if (locale === "ko") return ko_guide_what_is_json_intro(inputs)
	return ja_guide_what_is_json_intro(inputs)
});